import { KeycloakService } from 'keycloak-angular';
import { environment } from 'environments/environment';

/**
 * Initializes Keycloak before Angular bootstraps. Uses authorization-code flow (with PKCE)
 * and relies on the Keycloak login theme configured on the server.
 */
export function initializeKeycloak(keycloak: KeycloakService) {
  return () =>
    keycloak.init({
      config: {
        url: environment.ssoBaseUrl,
        realm: environment.ssoRealmName,
        clientId: environment.ssoClientId,
      },
      initOptions: {
        onLoad: 'check-sso',
        checkLoginIframe: false,
        pkceMethod: 'S256',
        silentCheckSsoRedirectUri: `${window.location.origin}/assets/silent-check-sso.html`,
      },
      enableBearerInterceptor: true,
      bearerPrefix: 'Bearer',
      bearerExcludedUrls: ['/assets'],
    });
}
